const showDebuggerMessages =
  import.meta.env.VITE_SHOW_CONSOLE_DEBUGGER === 'true'
const isRunningInBrowser = import.meta.env.SSR === false

let appSignalService = null
let appSignalImportPromise = null

const loadAppSignalService = () => {
  if (!isRunningInBrowser) return Promise.resolve(null)

  if (appSignalService) {
    return Promise.resolve(appSignalService)
  }

  if (!appSignalImportPromise) {
    appSignalImportPromise = import('@/services/appsignal')
      .then(({ appSignalService: loadedAppSignalService }) => {
        appSignalService = loadedAppSignalService
        return appSignalService
      })
      .catch(() => {
        appSignalImportPromise = null
        return null
      })
  }

  return appSignalImportPromise
}

const addAppSignalBreadcrumb = (action) => {
  if (!isRunningInBrowser) return

  if (appSignalService) {
    appSignalService.addBreadcrumb({
      category: 'Debug',
      action,
    })

    return
  }

  loadAppSignalService().then((loadedAppSignalService) => {
    if (!loadedAppSignalService) return

    loadedAppSignalService.addBreadcrumb({
      category: 'Debug',
      action,
    })
  })
}

export const useDebugger = () => {
  const $debug = (message) => {
    const formattedMessage = String(message)

    addAppSignalBreadcrumb(formattedMessage)

    if (!showDebuggerMessages) return

    console.log(
      `%c [Debug] ${formattedMessage} `,
      'background: #0000cc; color: #ffffff',
    )
  }

  return {
    $debug,
  }
}
